/* eslint global-require: "off" */

import React, { Component } from 'react';
import Helmet from 'react-helmet';
// import { asyncConnect } from 'redux-connect';
// import { connect } from 'react-redux';

// import commonUtil from '../../utils/commonUtil';

// import * as labelsActions from '../../components/labels/actions';

// const { isLablesLoaded, helthCheck } = labelsActions;
// const env = process.env.NODE_ENV;
// const instanceName = process.env.INSTANCE_NAME ? process.env.INSTANCE_NAME : '-Unknown-';

// @asyncConnect([{
//   deferred: false,
//   promise: ({ store: { dispatch, getState } }) => {
//     if (!isLablesLoaded(getState())) {
//       return dispatch(helthCheck());
//     }
//     return undefined;
//   },
// },
// ])

// @connect(store => ({
//   lables: store.labels,
//   // error: store.labels.error,
//   loading: store.labels.loading,
// }),
//   { ...labelsActions })

export default class Healthcheck extends Component {

  state = {
    showKitten: false,
  }

  // handleToggleKitten = () => this.setState({ showKitten: !this.state.showKitten })

  render() {
    return (
      <div className="container-fluid">
        <Helmet title="Health Check page........" />
        <h1>
          Liverpool Mesa de Regalos - Online App Health Check
        </h1>
        <h3>
          GR - Web online up and running.......................
        </h3>
      </div>
    );
  }
}
